export default __webpack_public_path__ + "scripts/resource/01f9298661d240cb845c00788b3fe9bd.svg";